import { apiGet, apiPost, apiPut, apiDelete } from '@/services/api/apiClient';

export interface Customer {
  _id: string;
  companyName: string;
  companyId?: string | null;
  gst: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  pinCode: string;
  email: string;
  mobile: string;
  isActive: boolean;
  isDeleted: boolean;
  remarks?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CustomerFormData {
  companyName: string;
  companyId?: string;
  gst: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  pinCode: string;
  email: string;
  mobile: string;
  isActive: boolean;
  remarks?: string;
}

export interface CustomerListParams {
  page?: number;
  limit?: number;
  search?: string;
  isActive?: boolean;
}

export interface CustomerListResponse {
  success: boolean;
  message: string;
  data: {
    docs: Customer[];
    totalDocs: number;
    limit: number;
    totalPages: number;
    page: number;
    pagingCounter: number;
    hasPrevPage: boolean;
    hasNextPage: boolean;
    prevPage: number | null;
    nextPage: number | null;
  };
}

export interface CustomerResponse {
  success: boolean;
  message: string;
  data: Customer;
}

class CustomerService {
  private baseUrl = '/customers';

  async getCustomers(params: CustomerListParams = {}): Promise<CustomerListResponse> {
    const queryParams = new URLSearchParams();
    
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    if (params.search) queryParams.append('search', params.search);
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive.toString());

    const url = `${this.baseUrl}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    return apiGet<CustomerListResponse>(url);
  }

  async createCustomer(data: CustomerFormData): Promise<CustomerResponse> {
    return apiPost<CustomerResponse>(this.baseUrl, data);
  }

  async updateCustomer(id: string, data: CustomerFormData): Promise<CustomerResponse> {
    return apiPut<CustomerResponse>(`${this.baseUrl}/${id}`, data);
  }

  async deleteCustomer(id: string): Promise<{ success: boolean; message: string }> {
    return apiDelete<{ success: boolean; message: string }>(`${this.baseUrl}/${id}`);
  }

  async getCustomerById(id: string): Promise<CustomerResponse> {
    return apiGet<CustomerResponse>(`${this.baseUrl}/${id}`);
  }
}

export const customerService = new CustomerService();